$('#modal-dialog .button--grey').on('click', function () {
	const $modal = $('#modal-dialog');
	const redirect = $modal.attr('data-redirect');
	$modal.removeClass('open');

	if (redirect) {
		window.location.href = redirect;
		return;
	}

	if ($modal.hasClass('reload-after-close')) {
		location.reload();
	}
});
